import { render, staticRenderFns } from "./OwnerShipModal.vue?vue&type=template&id=08cd1fb6"
import script from "./OwnerShipModal.vue?vue&type=script&lang=js"
export * from "./OwnerShipModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports